import React, { useEffect, useState } from 'react';
import classname from 'classnames';
import { Message, Icon } from 'zarm';
import { action } from '@iyunbao/cr-engine';

import {
  BaseWidgetProps,
  ActionProps,
  FetchProps,
} from '../utils/type';
import { createModel } from '../utils/modelStore';

export interface MessageProps extends BaseWidgetProps {
  label?: string;
  action?: ActionProps;
  icon?: any;
  imgIcon?: string;
  theme?: 'default'|'primary'|'success'|'warning'|'danger';
  size?: 'md'|'lg';
  hasArrow?: boolean;
  onClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  speed?: number;
  initFetch?: FetchProps;
  fetchCache?: any;
  onLog?: (name: string) => void;
  log?: string;
}

function UMessage(props: MessageProps) {
  const {
    prefixCls = 'crm-message',
    _crengine,
    label,
    theme = 'warning',
    size = 'md',
    className,
    speed = 0,
    initFetch,
    fetchCache,
    onLog,
    log,
    ...rest
  } = props;
  const cls = classname(prefixCls, className);
  const [newLabel, setNewLabel] = useState(label);
  const [newAction, setNewAction] = useState(rest.action);

  // 从接口获取数据
  useEffect(() => {
    if (!(initFetch)) {
      return () => {};
    }

    const cacheExpire: any = ((fetchCache && fetchCache.expire) ? fetchCache.expire : 0);
    const cacheParams: any = ((fetchCache && fetchCache.params) ? fetchCache.params : null);
    // 缓存名字
    let cacheName = 'scrollBarData';

    if (fetchCache && fetchCache.name) {
      cacheName = fetchCache.name;
    }

    const defaultOption = {
      method: 'GET',
      data: {},
      ...initFetch,
    };

    createModel(`select_async_${cacheName}`, defaultOption, cacheExpire, cacheParams)
      .execute((result) => {
        if (result) {
          try {
            const { data } = result;
            data.label && setNewLabel(data.label);
            data.action && setNewAction(data.action);
          } catch (error) {
            console.error('请确认返回格式， 是否有label或者action', result);
          }
        }
        return null;
      });
    return () => {};
  }, [initFetch, fetchCache]);

  useEffect(() => {
    setNewLabel(label);
  }, [label]);

  useEffect(() => {
    setNewAction(rest.action);
  }, [rest.action]);

  const onAction = (actions: any) => {
    if (!actions) {
      return false;
    }

    const { action: wAction } = _crengine || {};

    if (wAction) {
      wAction(actions);
      return false;
    }

    // 埋点
    (onLog && log) && onLog(log);

    const { type, data } = actions;

    if (action[type]) {
      action[type](data);
    }
  };

  const renderScrollLable = () => {
    const styleObj = rest.style || {};
    return (
      <div className="w-scroll-label" style={styleObj}>
        <div className="label-content" style={{ animationDuration: `${speed}s` }}>{newLabel}</div>
      </div>
    );
  };

  // 图标
  if (rest.icon) {
    rest.icon = <Icon type={rest.icon} />;
  }

  if (rest.imgIcon) {
    rest.icon = <img className="img-icon" src={rest.imgIcon} alt="" />;
  }

  // 动作
  if (rest.action || newAction) {
    const operation = rest.action || newAction;
    rest.hasArrow = true;
    rest.onClick = () => onAction(operation);
  }

  if (newLabel) {
    return (
      <Message
        {...rest}
        theme={theme}
        size={size}
        className={cls}
      >
        { speed === 0 ? newLabel : renderScrollLable()}
      </Message>
    );
  }

  return null;
}

export default UMessage;
